module.exports = __webpack_public_path__ + "static/media/CancelGoupLeaveBigIcon.ae8c12cb.svg";